import React from 'react';
import { Button, Card, Label, Transition } from 'semantic-ui-react';

import { formatPrice, getExpiredDate } from 'src/utils/helper';

import Base from './Base';
import dayjs from 'src/libs/dayjs';

type Props = {
  endDate: string;
  startDate: string;
  price?: number;
  floorPrice?: boolean;
  active?: boolean;
  onButtonClick?: (isActive: boolean) => void;
  isMobile?: boolean;
  multiplePrices?: boolean;
  type: Model.Class['type'];
  onContact?: () => void;
  class_user?: Model.ClassUser;
  showToIvaArchived?: boolean;
  isPublished?: boolean;
};

export default class Course extends Base<Props> {
  render() {
    const {
      onClick,
      endDate,
      startDate,
      price,
      floorPrice,
      active,
      onButtonClick,
      isMobile,
      multiplePrices,
      type,
      onContact,
      class_user,
      showToIvaArchived,
      isPublished,
    } = this.props;

    const { expired_date, dateLeft = 0 } = class_user
      ? getExpiredDate(class_user)
      : { expired_date: undefined };

    const renderColor = () => {
      if (type === 'ACCELERATOR' || type === 'CISL') {
        return 'purple';
      }

      if (active && dateLeft <= 0) {
        return 'red';
      }

      if (active && dateLeft <= 14) {
        return 'orange';
      }

      if (active) {
        return 'green';
      }

      return 'purple';
    };

    const renderStatusColor = () => {
      if (!isPublished && showToIvaArchived) {
        return 'grey';
      }
      if (type === 'LAUNCHPAD') {
        return 'purple';
      }
      if (!price) {
        return 'grey';
      }
      if (dayjs().isAfter(dayjs(endDate))) {
        return 'green';
      }
      if (
        dayjs().isAfter(dayjs(startDate)) &&
        dayjs().isBefore(dayjs(endDate))
      ) {
        return 'yellow';
      }
      if (dayjs().isBefore(dayjs(startDate))) {
        return 'grey';
      }
      return 'purple';
    };
    const renderStatusText = () => {
      if (!isPublished && showToIvaArchived) {
        return 'Archived';
      }
      if (type === 'LAUNCHPAD') {
        return 'Available';
      }
      if (!price) {
        return 'Invite only';
      }
      if (dayjs().isAfter(dayjs(endDate))) {
        return 'Finished';
      }
      if (
        dayjs().isAfter(dayjs(startDate)) &&
        dayjs().isBefore(dayjs(endDate))
      ) {
        return 'Ongoing';
      }
      if (dayjs().isBefore(dayjs(startDate))) {
        return 'Starting Soon';
      }
      return 'Available';
    };

    return (
      <Transition animation="fade down" transitionOnMount duration={500}>
        <Card fluid onClick={onClick}>
          <Card.Content extra className="mt-0 mb-24">
            {(!isMobile || !active) &&
              (price || (active && expired_date)) &&
              !(!isPublished && showToIvaArchived) && (
                <Label
                  size="large"
                  as="span"
                  color={renderColor()}
                  ribbon
                  className="card-label"
                >
                  {type === 'ACCELERATOR' || type === 'CISL' ? (
                    <React.Fragment>
                      {multiplePrices && (
                        <React.Fragment>
                          <span style={{ textTransform: 'capitalize' }}>
                            From
                          </span>{' '}
                        </React.Fragment>
                      )}
                      {formatPrice(price, {
                        floor: floorPrice,
                      })}
                    </React.Fragment>
                  ) : active && expired_date ? (
                    <React.Fragment>
                      <span style={{ textTransform: 'capitalize' }}>Valid</span>{' '}
                      <span style={{ textTransform: 'lowercase' }}>until</span>{' '}
                      {expired_date}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      {multiplePrices && (
                        <React.Fragment>
                          <span style={{ textTransform: 'capitalize' }}>
                            From
                          </span>{' '}
                        </React.Fragment>
                      )}
                      {formatPrice(price, {
                        floor: floorPrice,
                      })}{' '}
                      <span style={{ textTransform: 'capitalize' }}>
                        / month
                      </span>
                    </React.Fragment>
                  )}
                </Label>
              )}
            <Label
              basic
              color={renderStatusColor()}
              className="mt-0"
              style={{ float: 'right' }}
            >
              {renderStatusText()}
            </Label>
          </Card.Content>
          {this.renderBase({ metaCls: 'fs-16' })}
          <Card.Content extra>
            {!(!isPublished && showToIvaArchived) && (
              <>
                {active ? (
                  <Button
                    basic
                    fluid
                    primary
                    onClick={(event) => {
                      event.stopPropagation();
                      onButtonClick?.(!!active);
                    }}
                  >
                    See Course
                  </Button>
                ) : type === 'LAUNCHPAD' ? (
                  <Button
                    fluid
                    primary
                    onClick={(event) => {
                      event.stopPropagation();
                      onButtonClick?.(!!active);
                    }}
                  >
                    {`Buy`}
                  </Button>
                ) : (
                  <Button
                    fluid
                    primary
                    onClick={(event) => {
                      event.stopPropagation();
                      onContact?.();
                    }}
                  >
                    {`I am Interested`}
                  </Button>
                )}
              </>
            )}
          </Card.Content>
        </Card>
      </Transition>
    );
  }
}
